/* eslint-disable react/jsx-pascal-case */
import { Col, DatePicker, ConfigProvider, Form, Input, Row, Button, Select, InputNumber } from "./../../ui/ot";
import dayjs from 'dayjs';
import React, { useEffect, useState, useRef } from "react";
import { UploadImg } from '../../ui/ot'

const ClassifyStructureTypeCarouselForm = (
    {
        propsForm = null,
        formReloadCount = 0,
        onFormFinish = () => { },
        field: field_
    }
) => {
    const [form] = Form.useForm();
    const [files, setFiles] = useState([])
    const [content, setContent] = useState("")
    const editor = useRef(null);
    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
            total: (formValues?.comments * formValues?.number) || 0
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }

    }
    const onChangeFileValue = (values) => {
        let file = values?.classify_structure_type_file_data?.map(item => (
            {
                file_id: item.file_id,
                uid: item.file_id,
            }
        )) ?? []
        setFiles(file)
    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    }
    const onFinish = (values) => {
        // onFormFinish({
        //     ...values,
        // })
        const formattedValues = {
            ...values,
            // 確保 start_time 和 end_time 是格式化後的字串
            start_time: values.start_time ? dayjs(values.start_time).format('YYYY-MM-DD HH:mm:ss') : null,
            end_time: values.end_time ? dayjs(values.end_time).format('YYYY-MM-DD HH:mm:ss') : null,
        };
        console.log('提交的資料: ', formattedValues); // 查看表單值是否正確
        // 將格式化後的資料發送給上層處理函數
        onFormFinish(formattedValues);
    }
    const onValuesChange = () => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldValue(field_?.name)
        }
        else {
            formValues = form.getFieldValue(field_?.name)
        }
        setFormValuesOtherThings(formValues)
    }
    const onContentChange = (content) => {
        setContent(content)
        if (propsForm) {
            propsForm.setFieldValue('news_content', content)
        }
        else {
            form.setFieldValue('news_content', content)
        }
    }
    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current < dayjs().subtract(1, "day").endOf('day');
    };
    const range = (start, end) => {
        const result = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    };

    const disabledDateTime = (current) => ({
        disabledHours: () => {
            let hour = dayjs().format("HH")
            let todayDate = dayjs().format('YYYY-MM-DD')
            let currentDate = dayjs(current).format('YYYY-MM-DD')
            if (todayDate === currentDate) {
                return range(0, 24).splice(0, parseInt(hour))
            }
            else {
                return range(0, 24).splice(0, 0)
            }
        },
        disabledMinutes: () => {
            let minutes = dayjs().format("mm")
            let hour = dayjs().format("HH")
            let todayDate = dayjs().format('YYYY-MM-DD')
            let currentDate = dayjs(current).format('YYYY-MM-DD')
            let currentHour = dayjs(current).format('HH')
            if (todayDate === currentDate && currentHour === hour) {
                return range(0, 60).splice(0, parseInt(minutes) + 5)
            }
            else {
                return range(0, 0)
            }
        },
        disabledSeconds: () => {
            return range(0, 0)
        },
    });
    useEffect(() => {
        setDataInitialization()
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldValue(field_?.name)
        }
        else {
            formValues = form.getFieldValue(field_?.name)
        }
        // setFormValuesOtherThings(formValues)
        onChangeFileValue(formValues)
        onContentChange(formValues?.news_content ?? "")
    }, [formReloadCount])
    return (
        <Row>

            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                name={[field_?.name, "classify_structure_type_carousel_id"]}
                            >
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                name={[field_?.name, "classify_structure_type_id"]}
                            >
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                name={[field_?.name, "carousel_id"]}
                            >
                            </Form.Item>
                        </Col>
                        <Form.List
                            name={[field_?.name, 'classify_structure_type_file_data']}
                        >
                            {
                                (fields, { add, remove }) => (
                                    <Row>
                                        {
                                            fields.map((field) => (<>
                                                <Col>
                                                    <Form.Item
                                                        name={[field.name, "classify_structure_type_file_id"]}
                                                        hidden={true}
                                                    >
                                                    </Form.Item>
                                                </Col>
                                                <Col>
                                                    <Form.Item
                                                        name={[field.name, "file_id"]}
                                                        hidden={true}
                                                    >
                                                    </Form.Item>
                                                </Col>
                                            </>))
                                        }
                                    </Row>
                                )
                            }
                        </Form.List>
                        <Col span={24}
                        >
                            <Form.Item
                                label={"圖片"}
                            >
                                <UploadImg
                                    api={'/component/file'}
                                    defaultValue={files}
                                    onImagesChange={(files) => {
                                        propsForm.setFieldValue([field_?.name, 'classify_structure_type_file_data'].join('.'),
                                            [
                                                {
                                                    file_id: files?.findLast(_ => true)?.file_id,
                                                }
                                            ]
                                        )
                                        setFiles([
                                            {
                                                uid: files?.findLast(_ => true)?.file_id,
                                                file_id: files?.findLast(_ => true)?.file_id,
                                            }
                                        ])
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={'優先順序'}
                                name={[field_?.name, "index"]}
                            >
                                <InputNumber />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={'連結'}
                                name={[field_?.name, "path"]}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>
                        {/* 新增開始時間 */}
                        <Col span={24}>
                            <Form.Item label={'開始時間'} name={[field_?.name, "start_time"]}>
                                <Input type="date" placeholder="請輸入日期" />
                            </Form.Item>
                        </Col>
                        {/* 新增結束時間 */}
                        <Col span={24}>
                            <Form.Item label={'結束時間'} name={[field_?.name, "end_time"]}>
                                <Input type="date" placeholder="請輸入日期" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>


    )
}


export default ClassifyStructureTypeCarouselForm;
